module.exports = __webpack_public_path__ + "static/media/integral_card_4.e08da2e1.png";